'use strict'

function hideUserSection($this) {
    $this.find('.user').addClass('d-none')
}

function showUserSection() {
    $('.user').removeClass('d-none')
}

function resetMenuPosition() {
    $('.nav-item.dropdown').find('.dropdown-menu').removeAttr('style');
}

//This function is triggered when (in desktop) user hovers over any menu item (category level 1)
//and adjust the left position of the megamenu to fit the screen
function handleMenuHover() {
    const $this = $(this)
    const left = -$this.offset().left
    const menu = $this.find('.dropdown-menu')
    menu.css({
        left: left
    })
}

//This function is triggered when (in mobile) user clicks on a category and lands in the next category level
//This saves the category name clicked in the past menu level and fills an element in the new menu with this value
function handleCategoryClick() {
    const $this = $(this)
    const categoryName = $this.find('.dropdown-item.top-category a').eq(0).text().trim()
    $('.back-to-category').text(categoryName)
    //When user is navigating inside categories, profile section should disappear
    hideUserSection($this)
}

function handleResize() {
    const screenWidth = $(document).width()
    //Events deppends on device screen width. Mobile and desktop events SHOULD NOT
    //be in the event buffer when they are not suppose to be triggered
    if(screenWidth >= 1200) {
        $('.nav-item.dropdown').on('mouseenter', handleMenuHover)
        $('.main-category-item').off('click', handleCategoryClick)
    }
    else {
        $('.nav-item.dropdown').off('mouseenter', handleMenuHover)
        $('.main-category-item').on('click', handleCategoryClick)
        resetMenuPosition()
    }
}

function handleTriggerMenuOpen(e) {
    e.preventDefault();
    const dropdownTriggerElement = $('.mobile-menu-hidden-element > .dropdown-toggle');

    if(dropdownTriggerElement.length) {
        dropdownTriggerElement.trigger('click');
    }
}

module.exports = {
    //Starts the menu-related events, on the first load and also checks every time window has a new size
    startResizeEvents: function () {
        handleResize()
        $(window).resize(handleResize)

        //Shows profile section when user exit from category
        $('.back button').on('click', showUserSection)
    },
    starListeners: function() {
        //Triggers the menu open animation in mobile
        $('.trigger-menu-open').on('click', handleTriggerMenuOpen);
    }
};